import React from 'react'

const DeployedTokenCube = ({
  position,
  onClick,
  highlighted,
  totalCount,
  disableTokenHover
}) => {
  // Basketball dimensions
  const width = 26.9587;
  const height = 28.9558;

  // Colors for the LIVE GAME purchased tokens
  const topColor = "#DCF06C";
  const sideColor = "#B2BF65"; // Darker accent shade
  const edgeColor = "#C5D860"; // Slightly darker yellow

  return (
    <svg
      x={position.x - width}
      y={position.y}
      width={width}
      height={height}
      viewBox="0 0 24.2 26"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      fill="none"
      className={disableTokenHover ? '' : 'cursor-pointer'}
    >
      {/* Selection/Highlighting Layer */}
      {highlighted && (
        <rect x="0" y="0" width="16" height="26" fill="#D1E2FE" opacity="0.58" rx="2" />
      )}

      <g transform="scale(1.5, 1.0)">
        {/* Bottom/Edge Piece */}
        <path d="M0.12793 23.6016L14.6366 23.7152L15.8683 25.7256L1.33973 25.7256L0.12793 23.6016Z" fill={edgeColor} />
        {/* Side Piece */}
        <path d="M14.6259 23.7235L14.6329 0.302413L15.8718 2.36848L15.859 25.7171L14.6259 23.7235Z" fill={sideColor} />
        {/* Top Main Piece */}
        <path d="M0.387134 0.259203L14.633 0.25915L14.6363 23.736L0.132987 23.6484L0.387134 0.259203Z" fill={topColor} />
      </g>

      {/* Token Count display */}
      <foreignObject x="0" y="0" width="24.2" height="23" style={{ pointerEvents: 'none' }}>
        <div xmlns="http://www.w3.org/1999/xhtml" className="flex items-center justify-center w-full h-full">
          <span className="text-[10px] font-bold text-black select-none">
            {totalCount}
          </span>
        </div>
      </foreignObject>
    </svg>
  )
}

export default DeployedTokenCube